export const platformData = [
  { id: 0, name: '全部平台' },
  { id: 1, name: '安卓' },
  { id: 2, name: 'iOS' },
  { id: 3, name: '微信小游戏' },
  { id: 4, name: 'PC' }
]

export const platformData2 = [
  { id: 1, name: '安卓' },
  { id: 2, name: 'IOS' },
  { id: 3, name: '小程序' },
  { id: 5, name: '鸿蒙' }
]
